<template lang="pug">
span
  v-menu(v-model="showMenu" offset-y rounded="lg" width="400" :close-on-content-click="false" attach nudge-bottom="4" z-index="11")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedTimeRange" outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
          .text-xs.font-semibold Time
          .px-1.neutral400--text | 
          .text-xs.primary--text.font-medium {{ selectedTimeRange[0] }} - {{ selectedTimeRange[1].slice(0, 5) }}
          v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Time
    .white
      .pa-6
        .text-sm.font-semibold.text-center Start time
        v-text-field(v-model="startTime" type="time")
        //- y-time-picker.py-4(:key="`start-${timePickerKey}`" v-model="startTime")
        v-divider.my-4
        .text-sm.font-semibold.text-center.py-4 End time:
        v-text-field(v-model="endTime" type="time")
        //- y-time-picker.py-4(:key="`end-${timePickerKey}`" v-model="endTime")
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(@click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(color="primary" depressed :disabled="!canProceed" @click="apply") {{ $t('apply') }}
</template>

<script>
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'
// import YTimePicker from '@/components/YTimePicker.vue'

export default {
  components: { FilterDetailContainer },
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    showMenu: false,
    selectedTimeRange: null,
    startTime: '00:00',
    endTime: '23:59',
    timePickerKey: 0
  }),
  watch: {
    showMenu(value) {
      if (value) {
        if (this.startTime === null || this.endTime === null) {
          this.timePickerKey++
        }
      }
    }
  },
  mounted () {
    this.apply()
  },
  computed: {
    timeRange () {
      if (!this.startTime || !this.endTime) {
        return null
      }
      const timeArray = [this.startTime, this.endTime]
      // Convert time strings to Date objects
      const dateObjects = timeArray.map(timeString => new Date(`2023-01-01T${timeString}`))
      // Sort the Date objects
      dateObjects.sort((a, b) => a - b)
      // Convert sorted Date objects back to time strings
      return dateObjects.map(date => {
        if (date.getHours() === 23 && date.getMinutes() === 59) {
          return date.toTimeString().slice(0, 5) + ':59.999'
        }

        return date.toTimeString().slice(0, 5)
      })
    },
    canProceed () {
      return this.timeRange !== null
    }
  },
  methods: {
    apply () {
      this.selectedTimeRange = [...this.timeRange]
      this.$emit('update:filter', { key: 'time_range', value: this.timeRange.join(',') })
      this.showMenu = false
    },
    clear () {
      this.startTime = null
      this.endTime = null
      this.selectedTimeRange = null
      this.$emit('update:filter', {})
    }
  }
}
</script>
